<template>
  <button
    class="cta-card"
    @click="$emit('click')"
    :data-event-category="eventCategory"
    data-event-depth="1"
    data-event-action="click"
    :data-signup-headline="signupHeadline"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "CtaCard",
  props: {
    eventCategory: {
      type: String,
      required: true
    },
    signupHeadline: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.cta-card {
  @include font-style(p, $color: $midnight);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: spacing(176px);
  min-width: spacing(176px);

  height: spacing(176px);
  padding: $spacing-8;

  text-align: center;

  background-color: $green;
  border-radius: $border-radius-4;

  cursor: pointer;

  &:hover {
    color: inherit;
  }

  ::v-deep mark {
    text-decoration: underline;
  }

  ::v-deep strong {
    display: inline-block;
  }
}
</style>
